import { useMemo } from "react";
import { Link } from "react-router-dom";

import type { HomeSme } from "../../../api/types";
import { useLive } from "../../../live/store";
import { Card } from "../../../ui";
import { useArrivals } from "../hooks";
import { mergeFeed, withoutAgentChatter } from "../model/people";
import { CounterRow, liveCounterItems } from "../parts/CounterRow";
import { FilesLine } from "../parts/FilesLine";
import { GettingStartedNote } from "../parts/GettingStartedNote";
import { HandOversWaiting } from "../parts/HandOversWaiting";
import { LiveFeed } from "../parts/LiveFeed";
import { WhatsNewList } from "../parts/WhatsNewList";

/** The SME's home (screen 2): the hand-overs waiting, the state of the discipline's files, and what is new. */
export function SmeHome({ home }: { home: HomeSme }) {
  const live = useLive();
  // The agent's starts and ends are for the engineer who talks to it, not for the SME's feed.
  const feed = useMemo(() => withoutAgentChatter(mergeFeed(home.live_feed, live.recent)), [home.live_feed, live.recent]);
  const feedIds = useMemo(() => feed.map((notice) => String(notice.number)), [feed]);
  const arrivals = useArrivals(feedIds);
  return (
    <div className="nv-home stack">
      {home.whats_new.first_visit && (
        <Card aria-labelledby="sme-welcome-title" className="nv-welcome">
          <h2 id="sme-welcome-title">Welcome</h2>
          <GettingStartedNote />
        </Card>
      )}
      <HandOversWaiting handOvers={home.hand_overs} />
      <CounterRow items={liveCounterItems(home.counters)} />
      <FilesLine status={home.files} />
      <div className="nv-grid">
        <Card aria-labelledby="sme-news-title" className="nv-grid__wide">
          <div className="nv-card__head">
            <h2 id="sme-news-title">What is new</h2>
            <Link to="/whats-new">Open what's new</Link>
          </div>
          <WhatsNewList news={home.whats_new} mode="panel" />
        </Card>
        <div className="nv-grid__side">
          <LiveFeed notices={feed} arrivals={arrivals} />
        </div>
      </div>
    </div>
  );
}
